<template lang="pug">
    .thankyou
        .container
            .row.py-5.mt-3
                .col-12.text-center
                    h2.bold Grazie della tua richiesta!
                    h5.mt-3 Verrai ricontattato al più presto da un esperto di Okaycars all'indirizzo mail: #[b {{email}}]
</template>
<script>
export default {
  name: 'ThankYou',
  computed: {
    email(){
      return this.$route.query.email || ''
    }
  }
}
</script>

<style lang="less" scoped>
    h5 {
        opacity: 0.7
    }
</style>
